/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { resolveColor } from '../../utils/common';

export const SkodaExpandMoreIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<g transform='translate(-12 10) rotate(-45)'>
			<path d="M14.172 9v10h10v2h-12V9h2z" />
		</g>
	</SvgIcon>;

export const SkodaCheckRounded: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props} viewBox="0 0 31 31" width={31} height={31}>
		<rect width="31" height="31" rx="15.5" />
		<path d="M9.7841 16.8892L14.4472 20.0037L20.5006 10.2955" strokeWidth="2" stroke='#ffffff' />
	</SvgIcon>;

export const SkodaCloseIcon: React.FC<{ strokeWidth?: number } & SvgIconProps> = (props) => {
	const { strokeWidth, color, ...other } = props;
	const theme = useTheme();

	const stroke = resolveColor(theme, color);
	const defaultStrokeWidth = 2;

	return (
		<SvgIcon {...other}>
			<path d='M1.5 1.5L22.5 22.5' stroke={stroke} strokeWidth={strokeWidth ?? defaultStrokeWidth} />
			<path d='M1.5 22.5L22.5 1.5' stroke={stroke} strokeWidth={strokeWidth ?? defaultStrokeWidth} />
		</SvgIcon>
	);
};

export const SkodaDownloadIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d='M6 16.5L18 16.5L18 18L6 18L6 16.5M15.1272 9.9152L16.176 10.9876L11.9984 15.0737L7.8448 10.986L8.8969 9.9169L12.0015 12.972M11.25 6.5L12.75 6.5L12.75 13L11.25 13L11.25 6.5' />
	</SvgIcon>;

export const SkodaArrowRight: React.FC<{ strokeWidth?: number } & SvgIconProps> = (props) => {
	const { strokeWidth, color, ...other } = props;
	const theme = useTheme();

	const stroke = resolveColor(theme, color);
	const defaultStrokeWidth = 2;

	return (
		<SvgIcon {...other}>
			<path d='M15 7L20 12L15 17' stroke={stroke} strokeWidth={strokeWidth ?? defaultStrokeWidth} fill='none' />
			<path d='M3 12L19 12' stroke={stroke} strokeWidth={strokeWidth ?? defaultStrokeWidth} fill='none' />
		</SvgIcon>
	);
};

export const DealerLocatorIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d='M8 21H2V8L6 2 17 2 21 8 21 21 15 21 15 18 8 18 8 21M4 19 6 19 6 16 17 16 17 19 19 19 19 10 17 10 14 12 9 12 6 10 4 10ZM4 8 6 8 9 10 14 10 17 8 19 8 16 4 7 4 4 8' />
	</SvgIcon>;

export const StationFuel: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path fillRule="evenodd" clipRule="evenodd" d='M8 2H7V3V28V30V37V38H8H11H11.4142L11.7071 37.7071L13.4142 36H18.5858L20.2929 37.7071L20.5858 38H21H24H25V37V30V28V3V2H24H8ZM9 36V30H23V36H21.4142L19.7071 34.2929L19.4142 34H19H13H12.5858L12.2929 34.2929L10.5858 36H9ZM9 28H23V4H9V28ZM32.7071 10.2929L28.7071 6.29289L27.2929 7.70711L31 11.4142V31C31 31.5523 30.5523 32 30 32C29.4477 32 29 31.5523 29 31V16H27V31C27 32.6569 28.3431 34 30 34C31.6569 34 33 32.6569 33 31V11V10.5858L32.7071 10.2929ZM13 12H19V10H13V12Z' />
	</SvgIcon>;

StationFuel.defaultProps = {
	viewBox: '0 0 40 40'
};

export const StationElectric: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path fillRule="evenodd" clipRule="evenodd" d='M5 2H6H22H23V3V28V30V37V38H22H19H18.5858L18.2929 37.7071L16.5858 36H11.4142L9.70711 37.7071L9.41421 38H9H6H5V37V30V28V3V2ZM7 30V36H8.58579L10.2929 34.2929L10.5858 34H11H17H17.4142L17.7071 34.2929L19.4142 36H21V30H7ZM21 28H7V4H21V28ZM31 17.8991V31C31 31.8272 30.7199 32.5943 30.1571 33.1571C29.5943 33.7199 28.8272 34 28 34C27.1728 34 26.4057 33.7199 25.8429 33.1571C25.2801 32.5943 25 31.8272 25 31V20H27V31C27 31.3728 27.1199 31.6057 27.2571 31.7429C27.3943 31.8801 27.6272 32 28 32C28.3728 32 28.6057 31.8801 28.7429 31.7429C28.8801 31.6057 29 31.3728 29 31V17.8991C26.7235 17.4332 25 15.41 25 13V11V10H26H27V6H29V10H31V6H33V10H34H35V11V13C35 15.41 33.2765 17.4332 31 17.8991ZM33 12H31H29H27V13C27 14.6477 28.3523 16 30 16C31.6477 16 33 14.6477 33 13V12ZM10.5576 14.4609L13.7576 9.46095L15.4422 10.5391L13.2272 14H16.5999H18.4272L17.4422 15.5391L14.2422 20.5391L12.5576 19.4609L14.7726 16H11.3999H9.57264L10.5576 14.4609Z' />
	</SvgIcon>;

StationElectric.defaultProps = {
	viewBox: '0 0 40 40'
};

export const ShareButtonIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d='M6.158 8.312A4.167 4.167 0 0 0 2 12.47a4.167 4.167 0 0 0 4.158 4.158c1.362 0 2.55-.643 3.317-1.633l3.367 2.45a3.3 3.3 0 0 0-.1.867 4.167 4.167 0 0 0 4.159 4.158 4.167 4.167 0 0 0 4.158-4.158 4.167 4.167 0 0 0-4.158-4.159c-1.188 0-2.277.52-3.02 1.312l-3.589-2.599c.025-.124.025-.247.025-.396 0-.124 0-.272-.025-.396l3.59-2.599a4.165 4.165 0 0 0 3.019 1.312 4.167 4.167 0 0 0 4.158-4.159 4.167 4.167 0 0 0-4.158-4.158 4.167 4.167 0 0 0-4.158 4.158c0 .297.024.594.099.867l-3.367 2.45a4.174 4.174 0 0 0-3.317-1.633Zm10.743.52c-1.262 0-2.203-.966-2.203-2.204 0-1.237.94-2.203 2.203-2.203 1.262 0 2.203.966 2.203 2.203 0 1.238-.94 2.203-2.203 2.203zm-10.743 5.84c-1.262 0-2.203-.965-2.203-2.203s.941-2.203 2.203-2.203c1.263 0 2.203.965 2.203 2.203s-.94 2.203-2.203 2.203zm10.743 1.436c1.262 0 2.203.965 2.203 2.203 0 1.237-.94 2.203-2.203 2.203-1.262 0-2.203-.966-2.203-2.203 0-1.238.94-2.203 2.203-2.203z' />
	</SvgIcon>;

export const CopyLinkIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1ZM8 13h8v-2H8Zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1 0 1.71-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' />
	</SvgIcon>;

export const FacebookIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d='M16.643 8.476h-3.165V6.4c0-.78.517-.961.88-.961h2.234V2.012L13.516 2c-3.414 0-4.191 2.556-4.191 4.192v2.284H7.35v3.531h1.975V22h4.153v-9.993h2.803z' />
	</SvgIcon>;

export const TwitterIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d='M22 5.797a8.164 8.164 0 0 1-2.357.646 4.11 4.11 0 0 0 1.804-2.27c-.792.47-1.67.812-2.605.996A4.103 4.103 0 0 0 11.85 8.91a11.65 11.65 0 0 1-8.458-4.287 4.082 4.082 0 0 0-.556 2.063 4.1 4.1 0 0 0 1.825 3.415 4.092 4.092 0 0 1-1.858-.513v.052a4.106 4.106 0 0 0 3.291 4.023 4.125 4.125 0 0 1-1.853.07 4.108 4.108 0 0 0 3.833 2.85A8.231 8.231 0 0 1 2 18.283a11.611 11.611 0 0 0 6.29 1.843c7.548 0 11.674-6.252 11.674-11.674 0-.178-.003-.356-.011-.532A8.31 8.31 0 0 0 22 5.797z' />
	</SvgIcon>;

export const LinkedinIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon {...props}>
		<path d='M6.477 22H2.33V8.647h4.147ZM4.4 6.825C3.075 6.825 2 5.727 2 4.401a2.401 2.401 0 0 1 4.803 0c0 1.326-1.076 2.424-2.402 2.424zM21.996 22h-4.138v-6.5c0-1.55-.031-3.536-2.156-3.536-2.156 0-2.486 1.683-2.486 3.424V22H9.074V8.647h3.977v1.821h.058c.554-1.049 1.906-2.156 3.923-2.156 4.197 0 4.968 2.763 4.968 6.353V22z' />
	</SvgIcon>;

export const DeleteIcon: React.FC<SvgIconProps> = (props) =>
	<SvgIcon viewBox="0 0 16 16" {...props}>
		<path d="M3.257 15.714H12.743L13.049 4.341H15.038V3.032H11.145V2.148C11.145 1.196 10.397 0.413999 9.292 0.413999H6.708C5.603 0.413999 4.855 1.196 4.855 2.148V3.032H0.962V4.341H2.951L3.257 15.714ZM6.351 2.301C6.351 1.961 6.64 1.672 6.98 1.672H9.02C9.36 1.672 9.649 1.961 9.649 2.301V3.032H6.351V2.301ZM4.566 14.405L4.362 4.341H11.638L11.434 14.405H4.566ZM5.943 13.487H7.218V5.259H5.943V13.487ZM8.782 13.487H10.057V5.259H8.782V13.487Z" />
	</SvgIcon>;